import { ClipLoader } from "react-spinners";

const BtnClickLoader = ({ isLoading }) => {
  const override = {
    loading: true,
    cssOverride: {},
    speedMultiplier: 1,
  };

  return (
    <ClipLoader
      color="#36d7b7"
      loading={isLoading}
      size={15}
      cssOverride={override}
      aria-label="Clip Loading"
      data-testid="loader"
    />
  );
};

export default BtnClickLoader;
